var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseAdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9598 29.3327C23.3236 29.3327 29.2932 23.3631 29.2932 15.9993C29.2932 8.63555 23.3236 2.66602 15.9598 2.66602C8.596 2.66602 2.62646 8.63555 2.62646 15.9993C2.62646 23.3631 8.596 29.3327 15.9598 29.3327Z",
    stroke: "#787004",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2932 19.3743V12.6277C14.2932 11.9877 14.0265 11.7344 13.3465 11.7344H11.6132C10.9332 11.7344 10.6665 11.9877 10.6665 12.6277V19.3743C10.6665 20.0143 10.9332 20.2676 11.6132 20.2676H13.3332C14.0265 20.2676 14.2932 20.0143 14.2932 19.3743Z",
    stroke: "#787004",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 19.3743V12.6277C21.3333 11.9877 21.0666 11.7344 20.3866 11.7344H18.6666C17.9866 11.7344 17.72 11.9877 17.72 12.6277V19.3743C17.72 20.0143 17.9866 20.2676 18.6666 20.2676H20.3866C21.0666 20.2676 21.3333 20.0143 21.3333 19.3743Z",
    stroke: "#787004",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseAdIcon);
export default __webpack_public_path__ + "static/media/pauseAdIcon.c0dcbe1f9eaef2fa0b7995be3672079b.svg";
export { ForwardRef as ReactComponent };